import fetch from 'auth/FetchInterceptor'

const PackageService = {}

PackageService.addPackage = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/Package',
        method: 'post',
        data: data,
    })
}

PackageService.getPackages = function (params) {
    return fetch({
        url:
            process.env.REACT_APP_API_URL +
            `portal/Package`,
        method: 'get',
        params,
    })
}

PackageService.deletePackage = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/Package/${params}`,
        method: 'delete',
        params,
    })
}

PackageService.getPackageDetail = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/Package/${params}`,
        method: 'get',
        params,
    })
}

PackageService.updatePackage = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/Package',
        method: 'put',
        data: data,
    })
}

PackageService.uploadAttachments = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/Package/UploadAttachments',
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },
        data,
    })
}

PackageService.addDefaultCost = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/DefaultCost',
        method: 'post',
        data: data,
    })
}

PackageService.getDefaultCost = function (params) {
    return fetch({
        url:
            process.env.REACT_APP_API_URL +
            `portal/DefaultCost`,
        method: 'get',
        params,
    })
}

PackageService.fetchDefaultCost = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/DefaultCost',
        method: 'get',
        params,
    })
}

PackageService.getWarrantyMaintenanceList = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/WarrantyPackage/GetWarrantyMaintenanceList',
        method: 'get',
        params,
    })
}

PackageService.getWarrantyMaintenanceListDynamic = function (params) {
    console.log("🚀 ~ params:", params);
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/WarrantyPackage/GetWarrantyMaintenanceListDynamic?index=${params.index}&size=10`,
        method: 'post',
        data: params.finalQuery,
    })
}

PackageService.assingPackageToChargePoint = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/WarrantyPackage/AssignPackageToChargePoint',
        method: 'post',
        data: data,
    })
}

PackageService.addExtendedMaintenance = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/WarrantyPackage/AddExtendedMaintenance',
        method: 'post',
        data: data,
    })
}

export default PackageService
